
import {IUserLogEntryBuilder} from './i.user.log.entry.builder';
import {IUserLogEntryOptions} from './i.user.log.entry.options';
import {UserLogEntryHelper}   from './user.log.entry.helper';

/**
 *
 * @class AuthorityBuilder
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class AuthorityBuilder implements IUserLogEntryBuilder {

  /** convert raw MongoDB user log entry into data that can construct a tree node */
  build(data: any, args: IUserLogEntryOptions): any {

    const u: string = data._id.match(/^cus-(.*)/i)[1];

    const parsed: any = UserLogEntryHelper.parseAuthority(data.m);

    let title: string = `Authority #${u}: `;

    /*
     * include the first authority in the title so they can get a sense of the
     * direction the train is moving in.
     *
     */

    if (parsed.authorities.length > 0) {

      const a = parsed.authorities[0];

      if (a.route != null) {

        title += `RT: ${a.route.id} `;
      }

      title += `${a.track.desc} TRK: (${a.track.id})`;
    }

    /* build the node! */

    return {
      id:                 data._id,
      seq:                parseInt(data.seq),
      index:              args.index,
      name:               title,
      hasChildren:        args.hasChildren,
      isExpanded:         args.isExpanded,
      type:               'authority',
      children:           args.children,
      parent:             args.parent,
      kids:               data.ch,
      tags:               data.tg,
      label:              data.lb,
      pkey:               data.pa,
      train:              parsed.train,
      follower:           parsed.follower,
      reason:             parsed.reason,
      proposedMoveExited: parsed.proposedMoveExited,
      authByFWD:          parsed.authByFWD,
      authorities:        parsed.authorities,
      opposingTrains:     parsed.opposingTrains,
      u
    };

  }
}
